/* global gtag_report_conversion */
import React from "react";
import { Container } from "react-bootstrap";
import { FiPhone, FiTag } from "react-icons/fi";
import "../styles/common.css";
import "../styles/hero.css";

const Hero = () => {
  return (
    <section className="hero-section d-flex align-items-center text-center text-white">
      <div className="hero-overlay w-100">
        <Container className="py-5">
          <h1 className="fw-bold mb-5 display-4 hero-h1">
            Gyors és Megbízható Akkumulátor Bikázás
          </h1>

          <h2 className="fw-normal mb-4 fs-1">
            Akkumulátor csere és gépjármű bikázás Pest megyében
          </h2>

          <p className="mb-5 fs-4">
            Ha autód nem indul, és úgy tűnik, hogy lemerült az akkumulátor, ne
            aggódj – mi a lehető legrövidebb időn belül a helyszínre érkezünk,
            és segítünk újra útnak indulni.
          </p>

          <h4 className="fw-normal mb-4 fs-1">Már 15 000 Ft-tól!</h4>

          {/* BUTTONS */}
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            {/* CALL BUTTON */}
            <a
              href="tel:+36206282000"
              className="call-btn px-4 py-3 fs-4 d-inline-flex align-items-center"
              onClick={() => {
                try {
                  if (typeof gtag_report_conversion === "function") {
                    gtag_report_conversion("tel:+36206282000");
                  }
                } catch (err) {
                  console.error("gtag_report_conversion error:", err);
                }
              }}
            >
              <FiPhone className="me-2" />
              +36 20 628 2000
            </a>

            {/* PRICE LIST BUTTON */}
            <a
              href="#pricing"
              className="call-btn px-4 py-3 fs-4 d-inline-flex align-items-center"
            >
              <FiTag className="me-2" />
              Árlista
            </a>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default Hero;
